import React, { useContext } from 'react';
import {
	ICreateSubcategoryModalContext,
	CreateSubcategoryModalContext,
} from '../../../../../../createSubcategoryModalContext/createSubcategoryModalState/createSubcategoryModalContext';
import { MenuTranslationForm } from 'components/TranslationForm/MenuTranslationForm';
import style from './Translations.module.scss';

interface ITranslations {
	isVisible: boolean;
}

const Translations: React.FC<ITranslations> = ({ isVisible }) => {
	const {
		setFetchedTranslations,
		setTranslationTab,
		changeNameTranslation,
		IDCustomer,
		translations,
		selectedTranslationTab,
	} = useContext<ICreateSubcategoryModalContext>(CreateSubcategoryModalContext);
	return (
		<MenuTranslationForm
			setFetchedTranslations={setFetchedTranslations}
			setTranslationTab={setTranslationTab}
			changeNameTranslation={changeNameTranslation}
			isVisible={isVisible}
			IDSelectedCustomer={IDCustomer}
			translations={translations}
			selectedTranslationTab={selectedTranslationTab}
			className={style.translationForm}
		/>
	);
};

export default Translations;
